import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import highchartsExp from 'highcharts/modules/exporting'

highchartsMore(Highcharts)
highchartsExp(Highcharts)

export default Highcharts



// WEBPACK FOOTER //
// ./src/jquery/analytics/highchartsConfig.js